/**
 * Grabs the Props we dump from the server into the DOM and exports them as a singleton.
 * This allows us to conveniently dump React Server Side props into the dom and use this file
 * to hydrate the redux store.
 *
 */

import log from 'loglevel'

const propsNode = document.getElementById('xb-props')

const serverData = (propsNode && propsNode.innerHTML) || '{}'

// TODO: Consider adding try/catch in future
const serverProps = JSON.parse(serverData)

// log the serverProps locally for easy introspection
// Can't dispatch a redux action because the store isn't ready when this file is called
log.info('INIT:xb:serverProps', serverProps)

export default serverProps
